export const INIT_STATE = {
    name: null,
    city_id: null,
    address: null,
    phone_number: null,
    opening_time: null,
    closing_time: null,
    map_url: null,
}

export const INIT_BANNER = {
    desktop_image_url: null,
    mobile_image_url: null,
}

export const FIELD_NAME_DETAIL = {
    name: 'Nama store',
    city_id: 'Kota',
    address: 'Alamat store',
    phone_number: 'Nomor handphone',
    opening_time: 'Jam buka',
    closing_time: 'Jam tutup',
    map_url: 'Link maps',
    desktop_image_url: 'Banner desktop',
    mobile_image_url: 'Banner mobile',
}
